import React from 'react'

export type CallTmStatus = {
  id: number
  name: string
  removed: boolean
  tmCampaignId: number
}

type State = {
  statuses: CallTmStatus[]
}

export const CallTmStatusManagerContext = React.createContext<State>({
  statuses: [],
})

type Props = {
  statuses: CallTmStatus[]
  children: React.ReactNode
}

const CallTmStatusManager: React.FC<Props> = ({ statuses, children }) => {
  return (
    <CallTmStatusManagerContext.Provider
      value={{
        statuses,
      }}
    >
      {children}
    </CallTmStatusManagerContext.Provider>
  )
}

export default CallTmStatusManager
